var map = {
	"./Badge0.png": 9304,
	"./Badge1.png": 9783,
	"./Badge2.png": 6340,
	"./Badge3.png": 7498,
	"./Badge4.png": 6155,
	"./Badge5.png": 3320
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8649;